<template>
    <div class="performanceDetail">
        <!--<div class="performance_carousel">
            <img src="../../assets/images/performance/performance_banner.jpg" alt="">
        </div>-->
        <Swiper class="performance_carousel" v-if="performance_lists.child.length > 0" duration="1000">
            <Slide v-for="(item,index) in performance_lists.child" :key="index">
                <img :src="weburl+item.image" alt="">
            </Slide>
        </Swiper>

        <div class="performance_content">
            <div class="action_detail">
                <h2>{{performance_lists.title}}</h2>
                <p class="word" v-html="performance_lists.intro"></p>
                <h3>{{$t('show_time')}}</h3>
                <p v-html="performance_lists.show_time.replace(/\r\n/g,'<br>')"></p>
            </div>

        </div>
    </div>
</template>
<script>
    import {Swiper, Slide} from 'vue-swiper-component';
    export default {
        name: "performanceDetail",
        components: {
            Swiper,
            Slide
        },
        data: function () {
            return {
                performance_lists:{
                    child: [],
                    show_time:'\r\n'
                }
            }
        },
        created: function () {
            this.$store.commit("set_title", 'nav.performance');
            this.Show(this.$route.params.id);
            this.$store.commit("set_current", 4);
        },
        methods:{
            Show (i) {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/Perform/getPerform",
                    dataType: "json",
                    data: {
                        perform_id: i
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            if(res.data.result){
                                if(this.$i18n.locale !== "zh"){
                                    switch (i) {
                                        case '1':
                                            this.performance_lists = this.$t('perform_axios_1');
                                            break;
                                        case '2':
                                            this.performance_lists = this.$t('perform_axios_2');
                                            break;
                                        case '3':
                                            this.performance_lists = this.$t('perform_axios_3');
                                            break;
                                        case '4':
                                            this.performance_lists = this.$t('perform_axios_4');
                                            break;
                                        case '5':
                                            this.performance_lists = this.$t('perform_axios_5');
                                            break;
                                    }
                                }else {
                                    this.performance_lists = res.data.result;
                                }
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        },
        computed: {

            weburl: function () {
                return this.$store.state.weburl;
            }
        },

    }
</script>

<style scoped lang="less">
    @import '../../assets/less/common.less';

    .performanceDetail {
        width: @width;
        .performance_carousel {
            width: @width;
            /*height: 210px;*/
            img {
                width: @width;
                height: calc(100% + 1px);
            }
        }
        .performance_content {
            color: @font-primary;
            width: @width;
            height: 368px;
            background: url(../../assets/images/performance/performance_7.jpg) no-repeat 0 0;
            background-size: 100vw auto;
            .box-sizing;
            padding-top: 30px;
            @media (max-width: 320px) {
                height: 325px;
            }
            @media (max-width: 360px) {
                height: 365px;
            }
            @media (min-width: 411px) {
                height: 416px;
            }
            .action_detail {
                width: 70%;
                height: 234px;
                margin: auto;
                overflow: auto;
                @media(max-width: 320px){
                    height: 186px;
                }
                h2 {
                    text-align: center;
                    font-size: 1.2rem;
                    height: 28px;
                }
                p {
                    font-size: @font - .4;
                    line-height: 18px;
                    margin-bottom: 15px;
                    &.word {
                        text-indent: $font-size * 2;
                    }
                }
                h3 {
                    font-size: @font + .1;
                    margin-bottom: 10px;
                }
            }

        }
    }

    .action_detail::-webkit-scrollbar {
        display: none;
    }
    @media (min-width: 768px) and (orientation: portrait){
        .performanceDetail {
            .performance_content {
                height: 733px;
                padding-top: 65px;
                .action_detail {
                    width: 70%;
                    height:500px;
                    h2 {
                        font-size: 2rem;
                        height:60px;
                    }
                    p {
                        font-size: @font + .3;
                        line-height: 32px;
                        margin-bottom: 30px;
                        &.word {
                            text-indent: $font-size * 2;
                        }
                    }
                    h3 {
                        font-size: 1.7rem;
                        margin-bottom: 15px;
                    }
                }

            }
        }
    }
</style>
